/**
 * Настройки скрытой админки разработчиков.
 */

export const DEV_ROUTE = "/dev";
export const DEV_UNLOCK_CLICKS = 10;
export const DEV_UNLOCK_WINDOW_MS = 3500;
export const DEV_TOKEN_KEY = "dev_admin_token";

export const DEV_TABS = [
    { id: "dashboard", title: "Dashboard", hint: "статус API и сервиса" },
    { id: "chats", title: "Chats", hint: "сессии онлайн-чата" },
];

// config/dev.js
